<template>
  <div class="container">
    <!-- 系统维护公告条：仅 2026-02-27 及之前显示（含 27 号全天） -->
    <div class="maintenance-banner" v-if="showMaintenanceBanner">
      <div class="maintenance-banner__text">
        Уважаемые клиенты!
        В целях повышения качества обслуживания с 15 апреля мы проводим обновление продукта. В период обновления выдача займов будет временно приостановлена, при этом остальные функции будут работать в обычном режиме. Ожидается, что обновление займет около 3-4 недели. В случае изменения сроков мы своевременно уведомим вас.
        Приносим извинения за возможные неудобства и благодарим за понимание.
      </div>
    </div>
    <div class="minu" id="jump0">
      <div class="head">
        <div class="headLogo" @click="$router.push('/')">
          <img class="headLogo_img" src="../../static/img/logo.png" alt="" />
          <div class="headLogo_title">Быстрые займы.kz</div>
        </div>
        <div class="headMinu">
          <div class="headAbout">
            <div :class="headindex == 1 ? 'headAbout_text' : 'headAbout_textTwo'" @click="goFn(1)">О нас</div>
            <div :class="headindex == 2 ? 'headAbout_text' : 'headAbout_textTwo'" @click="goFn(2)">Как его получить?</div>
          </div>
          <div class="headLang">
            <div class="headLang_e">QZ</div>
            <div class="headLang_h">RU</div>
          </div>
          <div class="head_btn" @click="getlogin">Bойти</div>
        </div>
      </div>
    </div>

    <!-- 中间 -->
    <div class="minu_con">
      <div class="content">
        <div class="content_mi">
          <div class="content_mi-tit">Доступная сумма кредита</div>
          <div class="content_miNum">
            <img class="content_miNum-img" src="../../static/img/js.png" alt="" @click="getreduce" />
            <div style="text-align: center;margin-bottom: 0.27rem;">
              <span class="content_mi-num">{{unitConverter(loannum)}}</span>
              <span class="content_mi-f">〒</span>
            </div>
            <img class="content_miNum-img" src="../../static/img/zj.png" alt="" @click="getadd" />
          </div>
          <!-- <div class="content_mi-line"></div> -->
          <div class="content_mi-btn" @click="getlogin">Получить {{unitConverter(loannum)}} 〒</div>
          <div class="content_mi-text">*В зависимости от срока и сyммы микрокредита</div>
          <div class="content_mi-bom">
            <div class="content_mi-bom-text">Сумма к погашению</div>
            <div class="content_mi-bom-text">{{unitConverter(Interest)}} 〒</div>
          </div>
        </div>
        <div class="content_mi-down">
          <img class="content_mi-down-img" src="../../static/img/googleplay.png" alt="" @click="googleFn" />
          <img class="content_mi-down-img" src="../../static/img/AppStore.png" alt="" @click="appstoreFn" />
        </div>
      </div>
      <!-- Наше преимущество -->
      <div class="contTwo">
        <div class="contTwo_title">Наше преимущество</div>
        <div class="contTwo_min">
          <!-- Нет ипотеки, Полностью онлайн -->
          <div class="contTwo_div">
            <img class="contTwo_div-img" src="../../static/img/sj.png" alt="">
            <div class="contTwo_div-title">Нет ипотеки, Полностью онлайн</div>
            <div class="contTwo_div-text">Без залога и поручителей，В любое время и в любом месте действуйте на своем
              мобильном телефоне, и деньги будут переведены на вашу банковскую карту.</div>
          </div>
          <div class="contTwo_div">
            <img class="contTwo_div-img" src="../../static/img/1.png" alt="">
            <div class="contTwo_div-title">Удобный, Прозрачное кредитование</div>
            <div class="contTwo_div-text">Нет необходимости стоять в очереди, автоматическая проверка, кредит можно
              оформить за несколько минут. Низкие процентные ставки и полная прозрачность.</div>
          </div>
          <div class="contTwo_div">
            <img class="contTwo_div-img" src="../../static/img/g.png" alt="">
            <div class="contTwo_div-title">Отличный сервис, Безопасность</div>
            <div class="contTwo_div-text">Создавайте персонализированные решения для пользователей, Вся информация
              пользователей защищена и регулируется законом.</div>
          </div>
        </div>
      </div>
      <!-- Быстро взять — легко погасить -->
      <div style="margin-bottom: 0.63rem;">
        <div class="contTwo_title">Быстро взять — легко погасить</div>
        <div class="contThree">
          <div :class="switchIndex == 1 ? 'contThree_btn-y' : 'contThree_btn-n'" @click="getswitch(1)">Как оформить микрокредит</div>
          <div :class="switchIndex == 2 ? 'contThree_btn-y' : 'contThree_btn-n'" @click="getswitch(2)">Как погасить микрокредит</div>
        </div>
        <!-- Как оформить микрокредит -->
        <div class="contThree_minu" v-if="switchIndex == 1">
          <div class="contThree_minu-div">
            <img class="contThree_minu-div-img" src="../../static/img/o.png" alt="" />
            <div class="contThree_minu-div-title">Заполните анкету на сайте</div>
            <div class="contThree_minu-div-text">Вам понадобится документ, удостоверяющий личность, мобильный телефон и адрес электронный почты.</div>
          </div>
          <div class="contThree_minu-div">
            <img class="contThree_minu-div-img" src="../../static/img/t.png" alt="" />
            <div class="contThree_minu-div-title">Решение об одобрении онлайн</div>
            <div class="contThree_minu-div-text">Мы проверим вашу заявку и отправим вам решение моментально.</div>
          </div>
          <div class="contThree_minu-div">
            <img class="contThree_minu-div-img" src="../../static/img/s.png" alt="" />
            <div class="contThree_minu-div-title">Получение онлайн</div>
            <div class="contThree_minu-div-text">Деньги, одобренные по вашей заявке, поступят на вашу карту или счёт.</div>
          </div>
        </div>
        <!-- Как закрыть микрокредит -->
        <div class="contThree_minuTwo" v-if="switchIndex == 2">
          <div class="contThree_minu-div">
            <img class="contThree_minu-div-img" src="../../static/img/o.png" alt="" />
            <div class="contThree_minu-div-title">В личном кабинете</div>
            <div class="contThree_minu-div-textTwo">Закройте микрокредит мгновенно в личном кабинете любой банковской картой</div>
          </div>
        </div>
      </div>
      <!-- Скачайте приложение Moneyman -->
      <div class="cont_google">
        <div class="cont_google-title">Скачайте приложение Быстрые займы.kz</div>
        <img class="cont_google-img" src="../../static/img/googleplay.png" alt="" @click="googleFn" />
      </div>
      <!-- 详情  可滚动 -->
      <div class="minu_scroll" style="height: 0.8rem;overflow-y:auto;margin-bottom: 0.63rem;">
        <div class="minu_scroll-title">🇷🇺 Условия предоставления микрокредита</div>
        <div class="minu_scroll-title">Микрокредит предоставляется ТОО «Микрофинансовая организация» на следующих условиях:</div>
        <div class="minu_scroll-text">● Сумма микрокредита: определяется индивидуально при оформлении заявки.</div>
        <div class="minu_scroll-text">● Срок микрокредита: до 45 дней.</div>
        <div class="minu_scroll-text">● Дневная ставка вознаграждения: не более 0,3% в день.</div>
        <div class="minu_scroll-text">● Годовая эффективная ставка вознаграждения (ГЭСВ): не более 179%.</div>
        <div class="minu_scroll-text" style="margin-bottom: 0.1rem;">● Вознаграждение и комиссии: начисляются в соответствии с договором микрокредита.</div>
        <div class="minu_scroll-title">Способы оплаты:</div>
        <div class="minu_scroll-text">● мобильное приложение Kaspi Bank;</div>
          <div class="minu_scroll-text">● терминалы оплаты;</div>
          <div class="minu_scroll-text">● оплата на официальном сайте компании.</div>
          <div class="minu_scroll-text">Полные условия указаны в договоре микрокредита, доступном в приложении.</div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="bom">
      <div class="bom_title">Наши Контакты</div>
      <img class="bom_bg" src="../../static/img/d.png" alt="" />
      <div style="display: flex;justify-content: space-between;">
        <div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/tel.png" alt="" />
            <div class="bom_min-text">+7 775 030 8686</div>
          </div>
          <!-- <div class="bom_min" @click="wafn">
            <img class="bom_min-img" src="../../static/img/wa.png" alt="" />
            <div class="wa_btn">WhatsApp</div>
          </div> -->
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/time.png" alt="" />
            <div class="bom_text">Пн-Пт 10:00-19:00 Сб, Вс выходные</div>
          </div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/email.png" alt="" />
            <div class="bom_min-text-two">Support@fcredit.kz</div>
          </div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/add.png" alt="" />
            <div class="bom_min-two">Казахстан, город Алматы, Бостандыкский район, улица Еділ Ерғожин, здание 27, 46</div>
          </div>
        </div>

        <div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;margin-top: 0.08rem;" @click="homeFn(0)">Главная страница</div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;" @click="goFn(1)">О нас</div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;" @click="goFn(2)">Как его получить?</div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;" @click="goFn(3)">документ</div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;" @click="goFn(4)">Страховка</div>
        </div>

        <div>
          <div class="bom_text-two">Скачивай мобильное приложение через:</div>
          <div class="bomIMg" style="margin-bottom: 0.25rem">
            <img class="bom_img" style="margin-right: 0.1rem;" src="../../static/img/googleplay.png" alt="" @click="googleFn" />
            <img class="bom_img" src="../../static/img/AppStore.png" alt=""  @click="appstoreFn" />
          </div>
          <div class="payment_minu">
            <img class="payment_minu-img" style="margin-right: 0.1rem;" src="/static/img/mastercar.png" alt="" />
            <img class="payment_minu-img" src="/static/img/visa.png" alt="" />
          </div>
        </div>
      </div>
      <div class="iua">
        <img class="iua_q" @click="getwa" src="/static/img/waapp.png" alt="" />
      </div>
    <!-- 支付相关 -->
    <div class="payment">
        <div class="payment-line"></div>
        <div class="payment_text">ТОО «МФО ECKZ», Лицензия на осуществление микрофинансовой деятельности № 02.24.0011.М, от 12.09.2024 года,
          выдана Управлением региональных представителей в городе Алматы Агентства Республики Казахстан по регулированию
          и развитию финансового рынка.</div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    userStepData,
    cfgIndex
  } from '@/api/info'
  export default {
    name: "home",
    data() {
      return {
        headindex: -1,
        switchIndex: 1,
        loannum: 165000,//借款金额
        Interest: 0,//利息
        flage: false,
        source: '',//来源
        click_id: '',//h5代投需要的字段
        utm_term: '',//h5代投需要的字段
        lead_id: '',//h5代投需要的字段
        whatsappArr: '77476509659',
        WhatsAppphone: '',
        WhatsApplink: ''
      };
    },
    computed: {
      // 2026-02-27 及之前（含 27 号全天）显示维护公告条
      showMaintenanceBanner() {
        const cutoff = new Date('2026-04-17T00:00:00');
        return new Date() < cutoff;
      }
    },
    created() {
      if(this.loannum != 0) {
        this.Interest = this.loannum * 1.0001
      }
      this.cfgIndexfn()
    },
    mounted () {
      const urlParams = new URLSearchParams(window.location.search);
      this.source = urlParams.get('source') || '';
      this.click_id = urlParams.get('click_id') || '';
      this.utm_term = urlParams.get('utm_term') || '';
      this.lead_id = urlParams.get('lead_id') || '';
    },
    methods: {
      // 获取全局配置
      cfgIndexfn(){
        cfgIndex().then(res => {
          let WhatsAppphone = res.data.data.WhatsAppphone
          this.WhatsApplink = res.data.data.zhichiH5Url
          this.whatsappArr = res.data.data.WhatsAppphone
          this.WhatsAppphone = WhatsAppphone.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1 $2 $3 $4');
        })
      },
      // 跳转wa
      getwa(){
        location.href = 'https://sg.sobot.com/chat/h5/v7/index.html?sysnum=01c300067aff4d1d948990845d880606'
      },
      // 金额增加
      getadd(){
        if(this.loannum == 185000) return
        this.loannum += 5000; // 每次点击增加5000
        this.Interest = this.loannum * 1.0001
      },
      // 金额减少
      getreduce(){
        if(this.loannum >= 5000 && this.loannum != 10000){
          this.loannum -= 5000
          this.Interest = this.loannum * 1.0001
        }
      },
      translate(lang) {
        this.$i18n.locale = lang
      },
      unitConverter(e){
      	if (!e) return 0
      	 // 获取整数部分
      	 const intPart = Math.trunc(e)
      	 // 整数部分处理，增加,
      	 const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      	 // 预定义小数部分
      	 let floatPart = ''
      	 // 将数值截取为小数部分和整数部分
      	 const valueArray = e.toString().split('.')
      	 if (valueArray.length === 2) { // 有小数部分
      	   floatPart = valueArray[1].toString() // 取得小数部分
      	   return intPartFormat + '.' + floatPart
      	 }
      	 return intPartFormat + floatPart
      },
      goFn(type) {
        this.index = type
        if (type == 1) {
          this.$router.push('/about')
        } else if(type == 2){
          this.$router.push('/tutorial')
        }else if(type == 3){
          this.$router.push('/document')
        }else{
          this.$router.push('/Insurance')
        }
      },
      getlogin(){
        if(this.source){
          location.href = 'https://h5.fcredit.kz?sourceid=' + this.source + '&click_id=' + this.click_id + '&utm_term=' + this.utm_term + '&lead_id=' + this.lead_id
          return
        }
        if(this.flage) return
        this.flage = true
        userStepData().then(res => {
          if(localStorage.getItem('token')){
            if(res.data.code != 0){
              this.flage = false
              if(res.data.code == 301){
                this.$router.push('/login')
              }
            }else{
              this.flage = false
              var step = res.data.data.step
              if(step == 100){
                location.href = 'https://h5.fcredit.kz'
              }else if(step == 12){
                // this.$router.push('/underreview')
                location.href = 'https://h5.fcredit.kz'
              }else{
                this.$router.push('/login')
              }
            }
          }else{
            this.flage = false
            this.$router.push('/login')
          }
        })
      },
      homeFn(index) {
        if (index == 0) {
          document.querySelector("#jump" + index).scrollIntoView(true);
        }
      },
      googleFn() {
        location.href =
          'https://play.google.com/store/apps/details?id=loan.mfo.credit.tez.money.cash.zaim.pay.bank.card'
      },
      getswitch(index){
        this.switchIndex = index
      },
      appstoreFn() {
        location.href = 'https://h5.fcredit.kz'
        // this.$message({
        //   message: 'В стадии разработки'
        // });
      },
      wafn(){
        location.href = "https://api.whatsapp.com/send?phone=" + this.whatsappArr
      }
    },
  };
</script>
<style scoped>
  * {
    margin: 0;
    padding: 0;
    line-height: 1;
  }

  .container {
    background: #F6F8F8;
  }

  .maintenance-banner {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    background: #c0392b;
    color: #fff;
    padding: 0.12rem 0.3rem;
    text-align: center;
    box-shadow: 0 0.02rem 0.06rem rgba(0, 0, 0, 0.15);
  }

  .maintenance-banner__text {
    font-family: Roboto, Roboto;
    font-size: 0.07rem;
    line-height: 0.12rem;
    font-weight: 400;
    max-width: 100%;
  }

  .head {
    padding: 0.1rem 1.88rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #FFFFFF;
    margin-bottom: 0.42rem;
  }

  .headLogo {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .headLogo_img {
    width: 0.25rem;
    height: 0.19rem;
    margin-right: 0.07rem;
  }

  .headLogo_title {
    width: 0.41rem;
    height: 0.19rem;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.08rem;
    color: #0aba08;
    font-style: normal;
    cursor: pointer;
  }

  .headMinu {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .headAbout {
    width: 1.48rem;
    height: 0.23rem;
    line-height: 0.23rem;
    border-radius: 0.11rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.27rem;
    margin-right: 0.45rem;
  }

  .headAbout_text {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #333333;
    font-style: normal;
    cursor: pointer;
  }

  .headAbout_textTwo {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #999999;
    font-style: normal;
    cursor: pointer;
  }
  .headAbout_textTwo:hover{
    color: #06B804;
    cursor: pointer;
  }

  .headLang {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 0.29rem;
  }

  .headLang_e {
    width: 0.17rem;
    height: 0.17rem;
    line-height: 0.17rem;
    border-radius: 0.02rem;
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #fff;
    font-style: normal;
    margin-right: 0.07rem;
  }

  .headLang_h {
    width: 0.17rem;
    height: 0.17rem;
    line-height: 0.17rem;
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #fff;
    font-style: normal;
  }

  .head_btn {
    width: 0.75rem;
    height: 0.23rem;
    line-height: 0.23rem;
    text-align: center;
    background: #0ABA08;
    border-radius: 0.03rem;
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.08rem;
    color: #FFFFFF;
    font-style: normal;
    cursor: pointer;
  }

  /* 中间部分 */
  .minu_con {
    padding: 0 1.88rem;
  }

  .content {
    padding: 0.35rem 0.31rem;
    background-image: url(/static/img/tb.png);
    background-repeat: no-repeat;
    background-size: 100%;
    margin: 0 auto 0.63rem;
  }

  .content_mi {
    width: 2.46rem;
    background: #FFFFFF;
    box-shadow: 0rem 0.04rem 0.08rem 0rem rgba(9, 72, 9, 0.1);
    border-radius: 0.08rem;
    padding: 0.21rem 0.23rem;
    margin-bottom: 0.18rem;
  }

  .content_mi-tit {
    font-family: SFProText, SFProText;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    font-style: normal;
    margin-bottom: 0.15rem;
    text-align: center;
  }
  .content_miNum{
    width: 1.36rem;
    display: flex;
    justify-content: space-between;
    margin: auto;
  }
  .content_miNum-img{
    width: 0.17rem;
    height: 0.17rem;
    cursor: pointer;
  }
  .content_mi-num {
    font-family: SFProText, SFProText;
    font-weight: 600;
    font-size: 0.19rem;
    color: #1A1A1A;
    font-style: normal;
  }

  .content_mi-f {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    font-style: normal;
  }

  .content_mi-line {
    width: 2.05rem;
    height: 0.05rem;
    background: #06B804;
    border-radius: 0.03rem;
    margin-bottom: 0.1rem;
  }

  .content_mi-text {
    font-family: SFProText, SFProText;
    font-weight: 400;
    font-size: 0.06rem;
    color: #666666;
    font-style: normal;
    margin-bottom: 0.14rem;
  }

  .content_mi-btn {
    width: 2.45rem;
    height: 0.42rem;
    line-height: 0.42rem;
    background: linear-gradient(180deg, #FFBD00 0%, #FF9100 100%);
    border-radius: 0.08rem;
    font-family: SFProText, SFProText;
    font-weight: bold;
    font-size: 0.13rem;
    color: #FFFFFF;
    text-align: center;
    font-style: normal;
    margin-bottom: 0.08rem;
    cursor: pointer;
  }
  .content_mi-btn:hover {
    background: #06B804;
    cursor: pointer;
  }

  .content_mi-bom {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .content_mi-bom-text {
    font-family: SFProText, SFProText;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    font-style: normal;
  }
  .content_mi-down{
    margin-left: 0.55rem;
  }
  .content_mi-down-img{
    width: 0.74rem;
    height: 0.22rem;
    cursor: pointer;
  }
  .contTwo {
    margin-bottom: 0.36rem;
  }

  .contTwo_title {
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.18rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.31rem;
  }

  .contF_minu {
    width: 1.56rem;
    background: #FFFFFF;
    border-radius: 0.14rem;
    padding: 0.22rem 0.21rem;
  }
  .contF_minuHead{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.09rem;
  }
  .contF_minuHead-img{
    width: 0.31rem;
    height: 0.31rem;
    margin-right: 0.06rem;
  }
  .contF_minu-title {
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.05rem;
  }

  .contF_minu-img {
    width: 0.46rem;
    height: 0.08rem;
  }

  .contF_minu-text {
    width: 1.56rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    text-align: left;
    font-style: normal;
    /* margin-bottom: 0.22rem; */
  }

  .contF_minu-time {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    text-align: left;
    font-style: normal;
  }

  .contTwo_min {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .contTwo_div {
    height: 1.9rem;
    background: #FFFFFF;
    border-radius: 0.09rem;
    padding: 0 0.14rem;
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .contTwo_div-img {
    width: 0.36rem;
    height: 0.36rem;
    margin-bottom: 0.21rem;
  }

  .contTwo_div-title {
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.08rem;
  }

  .contTwo_div-text {
    width: 1.71rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    line-height: 0.1rem;
    font-style: normal;
  }

  .contThree {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .contThree_btn-y {
    width: 3.13rem;
    height: 0.42rem;
    line-height: 0.42rem;
    background: #FFFFFF;
    border-radius: 0.09rem;
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
    border-top: 0.03rem solid #06B804;
    cursor: pointer;
  }

  .contThree_btn-n {
    width: 3.13rem;
    height: 0.42rem;
    line-height: 0.42rem;
    background: #EFEFEF;
    border-radius: 0.09rem;
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.09rem;
    color: #C0C0C0;
    font-style: normal;
    cursor: pointer;
  }

  .contThree_minu {
    background: #FFFFFF;
    border-radius: 0.09rem;
    padding: 0.22rem 0.16rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .contThree_minuTwo{
    background: #FFFFFF;
    border-radius: 0.09rem;
    padding: 0.22rem 0.16rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .contThree_minu-div {
    text-align: center;
  }

  .contThree_minu-div-img {
    width: 0.16rem;
    height: 0.16rem;
    margin-bottom: 0.1rem;
  }

  .contThree_minu-div-title {
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.06rem;
  }

  .contThree_minu-div-text {
    width: 1.78rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    line-height: 0.1rem;
    font-style: normal;
  }
  .contThree_minu-div-textTwo{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    font-style: normal;
  }

  .contF {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
  }
  .contF_minuImg {
    position: absolute;
    top: 0.69rem;
    left: 0.25rem;
  }

  .contF_minuImg-left {
    width: 0.26rem;
    height: 0.26rem;
  }

  .contF_minuImgr {
    position: absolute;
    top: 0.69rem;
    right: 0.25rem;
  }

  .cont_google {
    background: #FFFFFF;
    border-radius: 0.09rem;
    padding: 0.21rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0.63rem;
  }

  .cont_google-title {
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.18rem;
    color: #333333;
    font-style: normal;
    margin-right: 0.31rem;
  }

  .cont_google-img {
    width: 1.06rem;
    height: 0.31rem;
    cursor: pointer;
  }
  .minu_scroll::-webkit-scrollbar {
    width: 0.02rem;
    height: 1.35rem;
  }
  .minu_scroll::-webkit-scrollbar-thumb{
    background-color: #06B804;
    border-radius: 0.01rem;
  }
  .minu_scroll::-webkit-scrollbar-track{
    background-color: #DDE3DC;
    border-radius: 0.01rem;
  }
  .minu_scroll-title {
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.06rem;
  }

  .minu_scroll-text {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #666666;
    font-style: normal;
    margin-bottom: 0.02rem;
  }

  /* 中间部分 end */
  .bom {
    padding: 0.44rem 1.96rem 0.24rem 1.88rem;
    background-color: #FFFFFF;
    position: relative;
  }
  .bom_bg{
    width: 2.6rem;
    height: 1.81rem;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .bom_title{
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.18rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.27rem;
  }
  .bom_min{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.2rem;
  }
  .bom_min-img{
    width: 0.23rem;
    height: 0.23rem;
    margin-right: 0.11rem;
  }
  .bom_min-text{
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
    cursor: pointer;
  }
  .wa_btn{
    width: 0.75rem;
    height: 0.23rem;
    line-height: 0.23rem;
    text-align: center;
    background: #0ABA08;
    border-radius: 0.03rem;
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.08rem;
    color: #FFFFFF;
    font-style: normal;
    cursor: pointer;
  }
  .bom_min-text-two{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
  }
  .bom_min-two{
    width: 2.17rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.09rem;
    color: #333333;
    line-height: 0.13rem;
    font-style: normal;
  }
  .bom_text {
    width: 0.88rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.09rem;
    color: #333333;
    line-height: 0.13rem;
    font-style: normal;
  }
  .bom_texte{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #06B804;
    margin-bottom: 0.09rem;
    font-style: normal;
  }

  .bom_text-two {
   width: 1.06rem;
   font-family: Roboto, Roboto;
   font-weight: 400;
   font-size: 0.09rem;
   color: #666666;
   line-height: 0.13rem;
   font-style: normal;
   margin-bottom: 0.1rem;
  }
  .bomIMg {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
  }

  .bom_img {
    width: 0.71rem;
    height: 0.21rem;
  }

  .payment {
    padding-right: 0.5rem;
    margin-top: 0.2rem;
  }
  .payment-line{
    width: 6.24rem;
    height: 0.01rem;
    background: #E3E3E3;
    margin-bottom: 0.2rem;
  }
  .payment_text {
    width: 5.46rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.07rem;
    color: #5C5C5C;
    line-height: 0.13rem;
    font-style: normal;
  }

  .payment_minu {
    width: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .payment_minu-img {
    width: 0.49rem;
    height: 0.31rem;
  }

  /deep/ .el-carousel__container{
    height: 1.65rem;
  }
  .iua{
    position: absolute;
    bottom: 1.25rem;
    right: 0.325rem;
  }
  .iua_q{
    width: 0.35rem;
    height: 0.35rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue